import { render } from "./formfileupload.vue?vue&type=template&id=6a61f244"
import script from "./formfileupload.vue?vue&type=script&lang=js"
export * from "./formfileupload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__